export const Notification = {
    add: 'notification.add',
    confirm: 'notification.confirm',
    initial: 'notification.initial',
};
